import React, { useState, useMemo, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import PartialTable from 'components/partials/PartialTable';
import { Form } from 'react-bootstrap';
import InputScanBin from '../InputScanBin';

const StockMoveTable = ({
  data,
  paging,
  total,
  nextPage,
  previousPage,
  gotoPage,
  handleInputChange,
  onPageSizeChange
}) => {
  const [rowState, setRowState] = useState({}); // { [rowId]: { moveQty, bin } }

  useEffect(() => {
    setRowState({});
    handleInputChange && handleInputChange({});
  }, [data]);

  const handleBinBarcode = useCallback(
    (rowId, bin) => {
      if (bin) {
        setRowState(prev => {
          const updated = {
            ...prev,
            [rowId]: { ...prev[rowId], bin }
          };
          handleInputChange && handleInputChange(updated);
          return updated;
        });
      }
    },
    [handleInputChange]
  );

  const handleMoveQtyChange = useCallback(
    (rowId, qty, productId) => {
      setRowState(prev => {
        const updated = {
          ...prev,
          [rowId]: { ...prev[rowId], id: rowId, moveQty: qty, productId }
        };
        handleInputChange && handleInputChange(updated);
        return updated;
      });
    },
    [handleInputChange]
  );

  const columns = useMemo(
    () => [
      {
        Header: '#',
        accessor: 'id',
        isVisible: true
      },
      {
        Header: 'Product Id',
        accessor: 'productId',
        isVisible: false
      },
      {
        Header: 'Emplas Code',
        accessor: 'productCode',
        required: true
      },
      {
        Header: 'Supplier Code',
        accessor: 'supplierCode'
      },
      {
        Header: 'Description',
        accessor: 'productDescription',
        disabled: true
      },
      {
        Header: 'Pack Qty',
        accessor: 'packQty',
        disabled: true,
        type: 'number'
      },
      {
        Header: 'M/units stock',
        accessor: 'mUnitStock',
        disabled: true,
        type: 'number'
      },
      {
        Header: 'Qty at location',
        accessor: 'qtyAtLocation',
        disabled: true,
        type: 'number'
      },
      {
        accessor: 'moveQty',
        Header: 'Move Qty',
        required: true,
        type: 'number',
        Cell: data => {
          const { id, productId } = data.row.original; // STOCK ID

          const [localValue, setLocalValue] = useState(
            rowState[id]?.moveQty ?? ''
          );

          const handleChange = e => {
            const value = e.target.value;
            setLocalValue(value);
          };

          const handleBlur = () => {
            handleMoveQtyChange(id, localValue, productId);
          };

          return (
            <Form.Control
              type="number"
              value={localValue}
              placeholder="Enter Qty"
              onChange={handleChange}
              onBlur={handleBlur}
            />
          );
        }
      },
      {
        accessor: 'desBin',
        Header: 'Destination Bin',
        required: true,
        Cell: data => {
          const { id } = data.row.original;
          const currentBin = rowState[id]?.bin?.binBarcode || '';
          return (
            <InputScanBin
              intialValue={currentBin}
              outputData={bin => handleBinBarcode(id, bin)}
              additionalClassName="col-12"
            />
          );
        }
      }
    ],
    [rowState, handleMoveQtyChange, handleBinBarcode]
  );

  return (
    <PartialTable
      data={data}
      columns={columns}
      paging={paging}
      total={total}
      nextPage={nextPage}
      previousPage={previousPage}
      gotoPage={gotoPage}
      onPageSizeChange={onPageSizeChange}
      handleClickRow={() => {}}
    />
  );
};

StockMoveTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  paging: PropTypes.object,
  total: PropTypes.number,
  nextPage: PropTypes.func,
  previousPage: PropTypes.func,
  gotoPage: PropTypes.func,
  onPageSizeChange: PropTypes.func,
  handleInputChange: PropTypes.func
};

export default StockMoveTable;
